/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DashboardFontesNaoSeladasTotalAnualCriteriaDto } from '../models/dashboard-fontes-nao-seladas-total-anual-criteria-dto';
import { DashboardFontesNaoSeladasTotalAnualPageDto } from '../models/dashboard-fontes-nao-seladas-total-anual-page-dto';


/**
 * Dashboard das Fontes Não Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class DashboardFontesNaoSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTotalAnualDashboardFontesNaoSeladas
   */
  static readonly GetTotalAnualDashboardFontesNaoSeladasPath = '/dashboard-fontes-nao-seladas/total-anual/{ano}';

  /**
   * Total autorizado por licenca - titular.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTotalAnualDashboardFontesNaoSeladas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalAnualDashboardFontesNaoSeladas$Response(params: {
    ano: number;
    criteria?: DashboardFontesNaoSeladasTotalAnualCriteriaDto;
  }): Observable<StrictHttpResponse<DashboardFontesNaoSeladasTotalAnualPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, DashboardFontesNaoSeladasService.GetTotalAnualDashboardFontesNaoSeladasPath, 'get');
    if (params) {
      rb.path('ano', params.ano, {});
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DashboardFontesNaoSeladasTotalAnualPageDto>;
      })
    );
  }

  /**
   * Total autorizado por licenca - titular.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTotalAnualDashboardFontesNaoSeladas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalAnualDashboardFontesNaoSeladas(params: {
    ano: number;
    criteria?: DashboardFontesNaoSeladasTotalAnualCriteriaDto;
  }): Observable<DashboardFontesNaoSeladasTotalAnualPageDto> {

    return this.getTotalAnualDashboardFontesNaoSeladas$Response(params).pipe(
      map((r: StrictHttpResponse<DashboardFontesNaoSeladasTotalAnualPageDto>) => r.body as DashboardFontesNaoSeladasTotalAnualPageDto)
    );
  }

}
